<template>
  <a-form :form="form">
    <a-form-item label="产品名称" 
      :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 4 }, xl: { span: 4 }, xxl: {span: 3}}" 
      :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 20}, xl: { span: 20}, xxl: {span: 21}}" 
      style="margin-bottom: 8px; text-align: right;">
      <a-input placeholder="产品名称" v-decorator="[ 'name', {rules: [{ required: true, message: '请输入用户名！'}]} ]"/>
    </a-form-item>
    <a-form-item label="产品代码" 
      :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 4 }, xl: { span: 4 }, xxl: {span: 3}}" 
      :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 20}, xl: { span: 20}, xxl: {span: 21}}" 
      style="margin-bottom: 8px; text-align: right;">
      <a-input placeholder="产品代码" v-decorator="[ 'sku', {rules: [{ required: true, message: '请输入代码！'}]} ]"/>
    </a-form-item>
    <a-form-item label="价格" 
      :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 4 }, xl: { span: 4 }, xxl: {span: 3}}" 
      :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 20}, xl: { span: 20}, xxl: {span: 21}}" 
      style="margin-bottom: 8px; text-align: right;">
      <a-input placeholder="价格" v-decorator="[ 'price', {rules: [{ required: true, message: '请输入价格！'}]} ]"/>
    </a-form-item>
    <a-form-item label="单位"
      :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 4 }, xl: { span: 4 }, xxl: {span: 3}}" 
      :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 20}, xl: { span: 20}, xxl: {span: 21}}" 
      style="margin-bottom: 8px; text-align: right;">
      <a-input placeholder="单位" v-decorator="[ 'unit_name', {rules: [{ required: true, message: '请输入价格！'}]} ]"/>
    </a-form-item>
    <a-form-item label="有效期"
      :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 4 }, xl: { span: 4 }, xxl: {span: 3}}" 
      :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 20}, xl: { span: 20}, xxl: {span: 21}}" 
      style="margin-bottom: 8px; text-align: right;">
      <a-input placeholder="有效期" v-decorator="[ 'service_span', {rules: [{ required: true, message: '请输入有效期！'}]} ]"/>
    </a-form-item>
    <a-row style="margin-bottom: 8px"> 
      <a-col :xs="6" :sm="6" :md="5" :lg="3" :xl="3" :xxl="2">
        <a-form-item label="产品详情" style="margin-bottom: 8px; text-align: right;">
        </a-form-item>
      </a-col>
      <a-col :xs="24" :sm="24" :md="19" :lg="21" :xl="21" :xxl="22">
        <a-row style="margin-top: 12px; margin-bottom: 8px; text-align: center;">
          <a-col :span="6">
            服务名称
          </a-col>
          <a-col :span="4">
            服务单价
          </a-col>
          <a-col :span="4">
            服务限制
          </a-col>
          <a-col :span="4">
            单位
          </a-col>
          <a-col :span="6">
            服务代码
          </a-col>
        </a-row>
        <a-row v-for="(feature, index) in features" :key="index" style="padding: 0px 0px;">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :span="6" style="margin-bottom: 8px;">
                <a-input placeholder="服务名称" v-model="feature.name"/>
              </a-col>
              <a-col :span="4" style="margin-bottom: 8px;">
                <a-input placeholder="服务单价" v-model="feature.price"/>
              </a-col>
              <a-col :span="4" style="margin-bottom: 8px;">
                <a-input placeholder="服务限制" v-model="feature.limit"/>
              </a-col>
              <a-col :span="4" style="margin-bottom: 8px;">
                <a-input placeholder="单位" v-model="feature.unit"/>
              </a-col>
              <a-col :span="6" style="margin-bottom: 8px;">
                <a-input placeholder="服务代码" v-model="feature.task"/>
              </a-col>
            </a-row>
          </a-form>
        </a-row>
        <a-button type="dashed" @click="addFeature">
          添加服务
        </a-button>
      </a-col>
    </a-row>
    <a-row>
      <a-form-item style="text-align: center; margin-bottom: 12px;">
        <a-button type="primary" @click="editProduct">{{edit}}</a-button>
      </a-form-item>
    </a-row>
  </a-form>
</template>

<script>

export default {
  name: 'EditProduct',
  props: {
    id: {
      type: String,
      default: function () {
        return ""
      }
    }
  },
  watch: {
    id: function(newvalue, oldvalue) {
      if (newvalue != "") {
        this.edit = "更改";
        let postdata = {
          task: "GET_PRODUCT_DETAIL",
          id: newvalue
        }
        let that = this;
        that.post("product", postdata)
          .then(function(data) {
            if (data.ret == 200) {
              that.product = data.data;
              that.form.setFieldsValue(
                that.product
              );
              that.features = JSON.parse(that.product.features);
            }
          }).catch(function (e) {
        });
      }
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      edit: "添加",
      product: {},
      features: [],
      refresh: 0
    }
  },
  methods: {
    editProduct: function () {
      let e = false;
      this.form.validateFields((err, values) => {
        if (err) {
          e = true;
          return;
        }
      });
      if (e) {
        return;
      }
      let item = this.form.domFields;
      let postdata = {};
      for (let key in item) {
        postdata[key] = this.form.getFieldValue(key);
      }
      postdata["features"] = this.features;
      if (this.id != "") {
        postdata["task"] = "UPDATE_PRODUCT_DETAIL";
        postdata["id"] = this.id;
      } else {
        postdata["task"] = "ADD_PRODUCT";
      }
      let that = this;
      that.post("product", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.$message.success(that.edit + "成功");
            that.$emit("change", postdata["task"]);
          } else {
            that.$message.error("失败");
          }
        }).catch(function (e) {
          that.$message.error("失败");
      });
    },
    addFeature: function () {
      this.features.push({
        name: "",
        price: "",
        limit: "",
        task: ""
      });
    }
  },
  created() {
    if (this.id != "") {
      this.edit = "更改";
      let postdata = {
        task: "GET_PRODUCT_DETAIL",
        id: this.id
      }
      let that = this;
      that.post("product", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.product = data.data;
            that.form.setFieldsValue(
              that.product
            );
            that.features = JSON.parse(that.product.features);
          }
        }).catch(function (e) {
      });
    }
  }
}
</script>

<style scoped>
</style>
